import { render } from "./HomeContent2-quote.vue?vue&type=template&id=12ada838&scoped=true"
const script = {}

import "./HomeContent2-quote.vue?vue&type=style&index=0&id=12ada838&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ada838"]])

export default __exports__